import { Fragment } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { ChartLine } from "@phosphor-icons/react";

import { SectionHeader } from "@/components/brand-intelligence/layout/heading";
import { MarketSentimentAnalysis } from "@/components/brand-intelligence/charts/market-sentiment";
import { SentimentAnalysis } from "@/components/brand-intelligence/metrics/sentiment-analysis";
import { MarketIntelligence } from "@/components/brand-intelligence/metrics/market-intelligence";
import { MarketShare } from "@/components/brand-intelligence/charts/market-shares";

export const Route = createFileRoute("/dashboard/research/_layout/$id/market")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Fragment>
      <SectionHeader title="Market Intelligence" icon={<ChartLine className="text-blue-500 size-6" />} iconClassName="bg-blue-500/10" />
      <MarketIntelligence />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
        <MarketSentimentAnalysis />
        <MarketShare />
      </div>
      <SentimentAnalysis />
    </Fragment>
  );
}
